/*!
 * @Author: luoob
 * @Date: 2021-03-23 14:52:00
 * @Last Modified by: luoob
 * @Last Modified time: 2021-03-23 14:52:00
 * @Introduction: 人物舆情模块路由
 */
const PersonHome = () => import('@/views/person/index.vue')
const PersonDetail = () => import('@/views/person/detail.vue')
const CreatePerson = () => import('@/views/person/create.vue')
const KeywordExamine = () => import('@/views/person/keywordExamine.vue')
const PersonSettle = () => import('@/views/person/settle.vue')
const PersonSettleDetail = () => import('@/views/person/settleDetail.vue')
const PersonAuth = () => import('@/views/person/auth.vue')
const PersonAuthDetail = () => import('@/views/person/auth_detail.vue')
const InfoEditList = () => import('@/views/person/infoEditList.vue')
const InfoEditDetail = () => import('@/views/person/infoEditDetail.vue')
const InterviewList = () => import('@/views/person/interviews.vue')
const InterviewDetail = () => import('@/views/person/interviewDetail.vue')
import Layout from '@/layout/index.vue'

export default {
    path: '/person',
    component: Layout,
    meta: {
        title: '人物舆情',
        icon: 'icon-V',
        alwaysShow: true // will always show the root menu
    },
    children: [
        {
            path: '',
            component: PersonHome,
            meta: {
                title: '人物列表'
            }
        },
        {
            path: 'keyword/examine',
            component: KeywordExamine,
            meta: {
                title: '关键词审核'
            }
        },
        {
            path: 'settle',
            component: PersonSettle,
            meta: {
                title: '收录审核'
            }
        },
        {
            path: 'settle/:id',
            component: PersonSettleDetail,
            meta: {
                title: '人物收录详情',
                hidden: true
            }
        },
        {
            path: 'auth',
            component: PersonAuth,
            meta: {
                title: '认证审核'
            }
        },
        {
            path: 'auth/:id',
            component: PersonAuthDetail,
            meta: {
                title: '人物认证详情',
                hidden: true
            }
        },
        {
            path: 'info/list',
            component: InfoEditList,
            meta: {
                title: '资料修改审核'
            }
        },
        {
            path: 'interview/list',
            component: InterviewList,
            meta: {
                title: '采访列表'
            }
        },
        {
            path: 'interview/:id',
            component: InterviewDetail,
            meta: {
                title: '采访详情',
                hidden: true
            }
        },
        {
            path: 'info/:id',
            component: InfoEditDetail,
            meta: {
                title: '人物修改信息详情',
                hidden: true
            }
        },
        {
            path: 'create',
            component: CreatePerson,
            meta: {
                title: '创建人物',
                hidden: true
            }
        },
        {
            path: ':id',
            component: PersonDetail,
            meta: {
                title: '人物详情',
                hidden: true
            }
        }
    ]
}
